/**
 * VENDOR MODULES
 */
import React from 'react';
import i18n  from "i18n";

/***/
function TricastTooltip() {
    const [active, setActive] = React.useState('tab-straight-tricast');

    return (
        <div className="straight-combination-tricast outcome-tooltip animate-mls-5">
            <div
              className={`
                tab-straight-tricast
                outcome-tooltip-item
                ${active == 'tab-straight-tricast' && 'active'}
              `}
              onClick={() => setActive('tab-straight-tricast')}
            >
              <span>{i18n.t(`IN_ORDER`)}</span>
            </div>
            <div
              className={`
                tab-combination-tricast
                outcome-tooltip-item
                ${active == 'tab-combination-tricast' && 'active'}
              `}
              onClick={() => setActive('tab-combination-tricast')}
            >
              <span>{i18n.t(`NOT_IN_ORDER`)}</span>
            </div>
        </div>
    );
}

export default TricastTooltip;

